import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const usePayment = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [paymentList, setPaymentList] = useState<PaymentListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.payment.list, location.search],
    () =>
      fetcher.payment.postPaymentList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',   
        status: searchParams.status ? String(searchParams.status) : 'request',   
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setPaymentList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { paymentList, searchResult, refetch };
};

export default usePayment;
